import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import type { ProviderRow } from '@/domain/providerConfig';
import { formatDateTimeWorded } from '@/utils/date';
import { parseLocale } from '@/utils/localeFormatters';

import { StatusPill } from './StatusPill';

import styles from './penRow.module.scss';

export interface PenHealthProps {
    row: ProviderRow;
    /** What sits at the end of the line, such as Fetch history. */
    action?: ReactNode;
}

/** What the daily fetch last did for a pen: when, and how many of the last 30 days hold data. */
function PenHealth({ row, action }: PenHealthProps) {
    const { t, i18n } = useTranslation();
    const fetchedAt = row.health.lastFetchedAt;
    return (
        <div className={styles.health}>
            {fetchedAt ? (
                <span>
                    {t('providerConfig.pens.lastFetched', {
                        time: formatDateTimeWorded(fetchedAt, 'second', parseLocale(i18n.language)),
                    })}
                </span>
            ) : (
                <StatusPill tone="neutral" label={t('providerConfig.pens.neverFetched')} />
            )}
            <span>{t('providerConfig.pens.daysWithData', { count: row.health.daysWithData })}</span>
            {action && <span className={styles.healthAction}>{action}</span>}
        </div>
    );
}

export default PenHealth;
export { PenHealth };
